import "./styles.scss";
import { ReactComponent as LeftCurl } from "../../assets/curl_right.svg";
import { ReactComponent as RightCurl } from "../../assets/curl_left.svg";
import LOGO3 from "../../assets/logob.webp";
import { useEffect } from "react";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import { gsap } from "gsap";

import ColorBlocks from "../ColorBlock/ColorBlocks";

export const Navbar = () => {
  useEffect(() => {
    gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

    gsap
      .timeline({
        scrollTrigger: {
          trigger: "#intro",
          start: "25% 20%",
          end: "30% 20%",
          scrub: true,
        },
      })
      .to(".navbarContainer", {
        backgroundColor: "black",
        height: "150px",
      });
  }, []);

  const handleScroll = (targetId) => {
    gsap.to(window, {
      duration: 0.5, // You can adjust the scroll duration
      scrollTo: {
        y: `#${targetId}`,
        offsetY: 300, // Optional offset to avoid scrolling behind a fixed navbar
      },
    });
  };

  return (
    <div>
      <div className="navbarContainer">
        <div
          className="blockContainer"
          style={{
            zIndex: 10,
            backgroundColor: "rgba(22, 22, 22, 1)",
          }}
        >
          <ColorBlocks />
        </div>
        <nav className="navbarWrapper">
          <LeftCurl className="curl left " />
          <div className="navbarItem" onClick={() => handleScroll("story")}>
            POVESTE
          </div>
          <div className="navbarItem" onClick={() => handleScroll("services")}>
            SERVICII
          </div>
          <img className="logo" alt="logo" src={LOGO3} />
          <div className="navbarItem" onClick={() => handleScroll("team")}>
            ECHIPA
          </div>
          <div className="navbarItem" onClick={() => handleScroll("contact")}>
            CONTACT
          </div>
          <RightCurl className="curl right " />
        </nav>
      </div>
    </div>
  );
};
